<template>
    <v-col class="tw-flex tw-h-full tw-flex-col">
        <v-row class="justify-center mb-5" no-gutters>
            <h3 class="ml-2">{{ $t('message.purchaseAgreement') }}</h3>
        </v-row>

        <!-- Scrollable agreement content -->
        <div
            class="purchase-agreement-container tw-mb-4 tw-flex-1 tw-overflow-y-auto tw-rounded-lg tw-border tw-border-gray-200 tw-p-4"
        >
            <div v-html="html" class="ordinary--text" />
        </div>

        <!-- Fixed bottom controls -->
        <div class="tw-mt-auto">
            <v-checkbox
                class="ordinary--text text-center tw-mb-4"
                :label="$t('message.agreeCheckbox')"
                v-model="hasAgreed"
            ></v-checkbox>

            <v-row no-gutters class="justify-end tw-gap-2">
                <v-btn text @click="emitCancel" class="!tw-uppercase">
                    {{ $t('message.cancel') }}
                </v-btn>

                <v-btn
                    :disabled="!hasAgreed"
                    color="primary"
                    @click="emitSuccess"
                    class="!tw-uppercase"
                >
                    {{ $t('message.proceedPayment') }}
                </v-btn>
            </v-row>
        </div>
    </v-col>
</template>
<script>
export default {
    props: {
        html: String,
    },
    data() {
        return {
            hasAgreed: false,
        }
    },
    methods: {
        emitSuccess() {
            this.$emit('success')
        },
        emitCancel() {
            this.$emit('cancel')
        },
    },
}
</script>
<style scoped>
.purchase-agreement-container {
    height: calc(100vh - 350px);
    min-height: 200px;
    max-height: 400px;

    /* Custom scrollbar styles */
    &::-webkit-scrollbar {
        width: 8px;
        height: 8px;
    }

    &::-webkit-scrollbar-track {
        @apply tw-bg-gray-100 tw-rounded-lg;
    }

    &::-webkit-scrollbar-thumb {
        @apply tw-bg-gray-400 tw-rounded-lg;
    }

    &::-webkit-scrollbar-thumb:hover {
        @apply tw-bg-gray-500;
    }
}
</style>